import React from 'react';
import { Helmet } from 'react-helmet-async';
import useCanonicalUrl from '../../hooks/useCanonicalUrl';

interface CanonicalLinkProps {
  /**
   * Optional custom path to use instead of current location
   * If not provided, uses the current page path
   */
  customPath?: string;
  /**
   * Whether to render the canonical link in development
   * Defaults to false for development, true for production
   */
  includeInDevelopment?: boolean;
}

/**
 * Component that adds a canonical link tag to the page head
 * Automatically generates the canonical URL based on current environment
 */
const CanonicalLink: React.FC<CanonicalLinkProps> = ({ 
  customPath, 
  includeInDevelopment = false 
}) => {
  const canonicalUrl = useCanonicalUrl(customPath);

  // Skip rendering in development unless explicitly requested
  if (process.env.NODE_ENV === 'development' && !includeInDevelopment) {
    return null;
  }

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

export default CanonicalLink; 